import { render, staticRenderFns } from "./ConnectionDataComponent.vue?vue&type=template&id=41cbe95f"
import script from "./ConnectionDataComponent.vue?vue&type=script&lang=js"
export * from "./ConnectionDataComponent.vue?vue&type=script&lang=js"
import style0 from "./ConnectionDataComponent.vue?vue&type=style&index=0&id=41cbe95f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAvatar,VCard,VCheckbox,VListItem,VListItemAction,VListItemContent,VSelect})
